import { OmpRequiredAnyOfFields, OmpRequiredSectionFields, OmpSampleDataNotes } from '../_models';

// Lookups and predicates over the OMP section config. The config itself lives in
// _models/omp.ts; this file is the behaviour that reads it.

export function ompSampleDataNote(key: string): string {
  return OmpSampleDataNotes[key] ? OmpSampleDataNotes[key] : '';
}

export function ompRequiredFields(key: string): string[] {
  return OmpRequiredSectionFields[key] ? OmpRequiredSectionFields[key] : [];
}

export function ompRequiredAnyOf(key: string): string[] {
  return OmpRequiredAnyOfFields[key] ? OmpRequiredAnyOfFields[key] : [];
}

export function ompFieldGroupLabel(fields: string[], label: (field: string) => string): string {
  return fields.map(label).join(' or ');
}

export function ompFieldIsEmpty(value: any): boolean {
  let empty = true;
  if (typeof value === 'string') {
    empty = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length === 0;
  } else if (value !== null && value !== undefined && value !== '' && value !== false) {
    empty = false;
  }
  return empty;
}

export function ompCtaEnabled(data: any): boolean {
  let enabled = false;
  if (data) {
    if (data.cta_enabled === undefined || data.cta_enabled === null) {
      enabled = !!data.cta_label;
    } else {
      enabled = !!data.cta_enabled;
    }
  }
  return enabled;
}
